<template>
  <div class="commentaires encart">
        <h2>Ajouter/Modifier le commentaire</h2>
        <form @submit.prevent="submit">
          <textarea id="commentaire_article" rows="8" v-model="commentaire_article"></textarea>
          <input type="hidden" id="utilisateur" v-model="utilisateur" required>
          <input type="hidden" id="codeArticle" v-model="codeArticle" required>
          <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chat-dots-fill" viewBox="0 0 16 16">
          <path d="M16 8c0 3.866-3.582 7-8 7a9.06 9.06 0 0 1-2.347-.306c-.584.296-1.925.864-4.181 1.234-.2.032-.352-.176-.273-.362.354-.836.674-1.95.77-2.966C.744 11.37 0 9.76 0 8c0-3.866 3.582-7 8-7s8 3.134 8 7zM5 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm4 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
          </svg>Envoyer mon commentaire</button>
  
          <div v-if="confirmationMessage" class="alert alert-success" role="alert">
              {{ confirmationMessage }}
          </div>
       
        </form>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      commentaire_article: '',
      codeArticle: '',
      utilisateur: '',
      confirmationMessage: '',
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;

    
  },
  mounted() { 

    const nom = VueCookies.get('nom')
    if (nom) {
        this.utilisateur = nom
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.utilisateur += " " + prenom;
    }

    // Envoyer les données du chantier au serveur
    axios.post('https://www.simef.fr/espace-client/api/getCommentaire.php', {
        codeArticle: this.codeArticle,
        utilisateur: this.utilisateur,
    })
    .then(response => {
        this.commentaire_article = response?.data?.[0]?.commentaire || '';
    })
    .catch(error => {
        console.error(error);
        this.refusMessage = "Une erreur est survenue";
    });
  }, 
  methods: {
        submit() {

            // Envoyer les données du chantier au serveur
            axios.post('https://www.simef.fr/espace-client/api/modifCommentaires.php', {
                commentaire_article: this.commentaire_article,
                codeArticle: this.codeArticle,
                utilisateur: this.utilisateur,
            })
            .then(response => {
                // Afficher message succès
                this.confirmationMessage = response.data.success;
            })
            .catch(error => {
                console.error(error);
                this.refusMessage = "Une erreur est survenue";
            });

          
        },
        
        
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  h2 {
    text-align: left;
  }

  .commentaires {
    text-align: left;
    margin-bottom: 30px;
    textarea {
      width: 100%;
      background: #fff;
      border: 0px;
      padding: 10px;
    }
  }

  button {
    margin-top: 15px!important;
    svg {
      margin-right: 15px;
    }
  }

  

</style>
